"use strict";
/// <reference path="./Wizard.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
const Utilities_1 = require("../../javascript/Utilities");
require("./Wizard.tmpl.less");
const wizardTemplate = require("./Wizard.tmpl.html");
class WizardImpl {
    static initAsync($elem, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = WizardImpl.getData($elem);
            if (!synData) {
                synData = $.extend({}, WizardImpl.DefaultOptions, options);
                if (Utilities_1.synUtil.clientDeviceClass === "phone")
                    synData.HeaderRenderingMode = "Classic";
                WizardImpl.setData($elem, synData);
                let templateData = {
                    guid: Utilities_1.synUtil.getGUID(),
                };
                let template = kendo.template(wizardTemplate);
                $elem.html("").append($(template(templateData)));
                // Check if steps are valid (and set startStep)
                const validGraph = yield WizardImpl.checkStepsAsync($elem);
                if (!validGraph) {
                    WizardImpl.printDotGraph($elem);
                    $.error("jQuery.synWizard received invalid WizardSteps. Please check the warnings and the provided graph for debugging");
                }
                else if (synData.OutputDebugGraph)
                    WizardImpl.printDotGraph($elem);
                // Setup the wizard and run the first step
                let synDataInternal = WizardImpl.getDataInternal($elem);
                let startStep = WizardImpl.getStepByName($elem, synDataInternal.startStep);
                synDataInternal.currentStep = startStep;
                synDataInternal.stepHistory = [];
                synDataInternal.haveRunSteps = [];
                Utilities_1.synUtil.beginAjaxProgress();
                yield WizardImpl.createWizardNavigationAsync($elem);
                yield startStep.run($elem);
                synDataInternal.haveRunSteps.push(startStep);
                synDataInternal.currentStepGUID = Utilities_1.synUtil.getGUID();
                Utilities_1.synUtil.endAjaxProgress();
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            let $this = $(this);
            WizardImpl.removeData($this);
            WizardImpl.removeDataInternal($this);
            $this.children().remove();
            $this.off("beginInit endInit synWizardCancel synWizardFinish");
        });
    }
    static enable($elem, enable) {
        return $elem.each(function () {
            let $this = $(this);
            if (enable !== false)
                $this.find(".synWizardDisableDiv").css("display", "none");
            else
                $this.find(".synWizardDisableDiv").css("display", "block");
        });
    }
    static getStepContentDiv($elem) {
        return $elem.find(".synWizardContent").first();
    }
    static enableNextButton($elem, enable = true) {
        if (enable === true)
            $elem.find(".synWizardBtn-next:not(.placeholder)").prop("disabled", false);
        else
            $elem.find(".synWizardBtn-next:not(.placeholder)").prop("disabled", true);
    }
    static hideBtnCancel($elem, hide = true) {
        if (hide === true)
            $elem.find(".synWizardBtn-cancel:not(.placeholder)").css("visibility", "hidden");
        else
            $elem.find(".synWizardBtn-cancel:not(.placeholder)").css("visibility", "visible");
    }
    static hideBtnPrevious($elem, hide = true) {
        if (hide === true) {
            $elem.find(".synWizardBtn-previous:not(.placeholder)").css("visibility", "hidden");
            $elem.find(".synWizardHistoryStep").addClass("navigationDisabled");
        }
        else {
            $elem.find(".synWizardBtn-previous:not(.placeholder)").css("visibility", "visible");
            $elem.find(".synWizardHistoryStep").removeClass("navigationDisabled");
        }
    }
    static hideBtnNext($elem, hide = true) {
        if (hide === true)
            $elem.find(".synWizardBtn-next:not(.placeholder)").css("visibility", "hidden");
        else
            $elem.find(".synWizardBtn-next:not(.placeholder)").css("visibility", "visible");
    }
    static getPathStorage($elem) {
        let synDataInternal = WizardImpl.getDataInternal($elem);
        for (let pathStorage of synDataInternal.pathStorage)
            if (synDataInternal.currentStep && synDataInternal.currentStep.name === pathStorage.step.name)
                return pathStorage.data;
        return {};
    }
    static getGlobalStorage($elem) {
        return WizardImpl.getDataInternal($elem).globalStorage;
    }
    static resetGlobalStorage($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            WizardImpl.getDataInternal($elem).globalStorage = {};
            yield WizardImpl.notifyGlobalStorageChanged($elem);
        });
    }
    static notifyGlobalStorageChanged($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Rebuild navigation due to possible changes in canReRun()
            Utilities_1.synUtil.beginAjaxProgress();
            yield WizardImpl.createWizardNavigationAsync($elem, true);
            Utilities_1.synUtil.endAjaxProgress();
        });
    }
    static evaluateCanReRun($wizard, step) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (step.canReRun == undefined)
                return true;
            else {
                const canReRunResult = step.canReRun($wizard);
                if (typeof canReRunResult === "boolean")
                    return canReRunResult;
                return yield canReRunResult;
            }
        });
    }
    static nextStep($elem, currentStepRan = true) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            Utilities_1.synUtil.beginAjaxProgress();
            let synData = WizardImpl.getData($elem);
            let synDataInternal = WizardImpl.getDataInternal($elem);
            try {
                if (synDataInternal.currentStep.nextPossibleSteps == undefined || synDataInternal.currentStep.nextPossibleSteps.length === 0) {
                    if (synDataInternal.currentStep.persist != undefined)
                        yield synDataInternal.currentStep.persist($elem);
                    synDataInternal.finished = true;
                    $elem.trigger("synWizardFinish");
                }
                else {
                    if (currentStepRan && synDataInternal.currentStep.persist != undefined)
                        yield synDataInternal.currentStep.persist($elem);
                    // Get the next step
                    let nextWizardStep;
                    if (synDataInternal.currentStep.nextPossibleSteps.length > 1) {
                        if (synDataInternal.currentStep.getNextStepName == undefined)
                            $.error(`getNextStepName() is undefined for step ${synDataInternal.currentStep.name} but nextPossibleSteps contains more that 1 element.`);
                        let nextStepName;
                        let nextStepNameOrPromise = synDataInternal.currentStep.getNextStepName($elem);
                        if (typeof nextStepNameOrPromise === "string")
                            nextStepName = nextStepNameOrPromise;
                        else
                            nextStepName = yield nextStepNameOrPromise;
                        nextWizardStep = WizardImpl.getStepByName($elem, nextStepName);
                    }
                    else
                        nextWizardStep = WizardImpl.getStepByName($elem, synDataInternal.currentStep.nextPossibleSteps[0]);
                    // Run next step (interrupt on error, run() should handle errors internally)
                    try {
                        let nextStepCanReRun = yield WizardImpl.evaluateCanReRun($elem, nextWizardStep);
                        // Always allow a step to run for the first time
                        if (synDataInternal.haveRunSteps.indexOf(nextWizardStep) === -1)
                            nextStepCanReRun = true;
                        WizardImpl.rebuildStepContentDiv($elem);
                        // Set up history and copy over pathStorage
                        if (synDataInternal.stepHistory && synDataInternal.currentStep)
                            synDataInternal.stepHistory.push(synDataInternal.currentStep);
                        synDataInternal.pathStorage.push({
                            step: nextWizardStep,
                            data: JSON.parse(JSON.stringify(WizardImpl.getPathStorage($elem))),
                        });
                        // Change the currentStep
                        synDataInternal.currentStep = nextWizardStep;
                        if (nextStepCanReRun) {
                            yield WizardImpl.createWizardNavigationAsync($elem);
                            yield synDataInternal.currentStep.run($elem);
                            synDataInternal.currentStepGUID = Utilities_1.synUtil.getGUID();
                            if (synDataInternal.haveRunSteps && synDataInternal.haveRunSteps.indexOf(synDataInternal.currentStep) === -1)
                                synDataInternal.haveRunSteps.push(synDataInternal.currentStep);
                            // Start endTimeout if endStep
                            if (synData.EndTimeoutMS && (synDataInternal.currentStep.nextPossibleSteps == undefined || synDataInternal.currentStep.nextPossibleSteps.length === 0)) {
                                let currentStepGUID = synDataInternal.currentStepGUID;
                                // Create timer in last step icon
                                let $currentStepIcon = $elem.find(".synWizardCurrentStep .synWizardStepIcon");
                                $currentStepIcon.empty();
                                let $timer = $("<span class='synWizardTimer'></span>");
                                $currentStepIcon.append($timer);
                                let timeoutTimer = function ($timerElem, startTime) {
                                    if (synDataInternal && synDataInternal.currentStep && synDataInternal.currentStepGUID === currentStepGUID) {
                                        if (synDataInternal.finished !== true) {
                                            let now = Date.now();
                                            let secondsElapsed = Math.floor((now - startTime) / 1000);
                                            let restSeconds = synData.EndTimeoutMS / 1000 - secondsElapsed;
                                            if (restSeconds <= 0)
                                                restSeconds = 0;
                                            $timerElem.text(restSeconds);
                                            // Timer finished
                                            if (restSeconds === 0)
                                                // Allow timer to visually get to 0 before calling nextStep
                                                window.setTimeout(() => { WizardImpl.nextStep($elem); }, 0);
                                            else
                                                window.setTimeout(() => { timeoutTimer($timerElem, startTime); }, 200);
                                        }
                                    }
                                };
                                timeoutTimer($timer, Date.now());
                            }
                        }
                        else
                            yield WizardImpl.nextStep($elem, false);
                    }
                    catch (err) {
                        $.error(err);
                    }
                }
                Utilities_1.synUtil.endAjaxProgress();
                return Promise.resolve();
            }
            catch (err) {
                Utilities_1.synUtil.endAjaxProgress();
                return Promise.reject(err);
            }
        });
    }
    static previousStep($elem, goToStep, cleanup = false, resetWizard = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            Utilities_1.synUtil.beginAjaxProgress();
            let synData = WizardImpl.getData($elem);
            let synDataInternal = WizardImpl.getDataInternal($elem);
            try {
                // Cleanup step
                if (synDataInternal.currentStep.cleanup != undefined)
                    yield synDataInternal.currentStep.cleanup($elem);
                // Remove pathStorage
                for (let i = synDataInternal.pathStorage.length - 1; i >= 0; --i) {
                    if (synDataInternal.pathStorage[i].step.name === synDataInternal.currentStep.name) {
                        synDataInternal.pathStorage.splice(i, 1);
                        break;
                    }
                }
                // Change the currentStep
                synDataInternal.currentStep = synDataInternal.stepHistory.pop();
                synDataInternal.currentStepGUID = Utilities_1.synUtil.getGUID();
                if (goToStep && goToStep.name !== synDataInternal.currentStep.name)
                    yield WizardImpl.previousStep($elem, goToStep, cleanup);
                else if (!goToStep && (yield WizardImpl.evaluateCanReRun($elem, synDataInternal.currentStep)) === false)
                    yield WizardImpl.previousStep($elem);
                else {
                    if (cleanup === true) {
                        if (synDataInternal.currentStep.cleanup != undefined)
                            yield synDataInternal.currentStep.cleanup($elem);
                        if (resetWizard === true) {
                            yield WizardImpl.resetWizard($elem);
                            WizardImpl.rebuildStepContentDiv($elem);
                            yield synDataInternal.currentStep.run($elem);
                            synDataInternal.haveRunSteps.push(synDataInternal.currentStep);
                            synDataInternal.currentStepGUID = Utilities_1.synUtil.getGUID();
                        }
                    }
                    else {
                        yield WizardImpl.createWizardNavigationAsync($elem);
                        WizardImpl.rebuildStepContentDiv($elem);
                        yield synDataInternal.currentStep.run($elem);
                    }
                }
                Utilities_1.synUtil.endAjaxProgress();
                return Promise.resolve();
            }
            catch (err) {
                Utilities_1.synUtil.endAjaxProgress();
                return Promise.reject(err);
            }
        });
    }
    static cleanup($elem, resetWizard = false) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            Utilities_1.synUtil.beginAjaxProgress();
            let synDataInternal = WizardImpl.getDataInternal($elem);
            if (synDataInternal.stepHistory.length > 0) {
                yield WizardImpl.previousStep($elem, synDataInternal.stepHistory[0], true, resetWizard);
            }
            else {
                if (synDataInternal.currentStep.cleanup != undefined)
                    yield synDataInternal.currentStep.cleanup($elem);
                if (resetWizard === true) {
                    yield WizardImpl.resetWizard($elem);
                    WizardImpl.rebuildStepContentDiv($elem);
                    yield synDataInternal.currentStep.run($elem);
                    if (synDataInternal.currentStep)
                        (_a = synDataInternal === null || synDataInternal === void 0 ? void 0 : synDataInternal.haveRunSteps) === null || _a === void 0 ? void 0 : _a.push(synDataInternal.currentStep);
                    synDataInternal.currentStepGUID = Utilities_1.synUtil.getGUID();
                }
            }
            Utilities_1.synUtil.endAjaxProgress();
        });
    }
    static getCurrentStepName($elem) {
        var _a;
        let synDataInternal = WizardImpl.getDataInternal($elem);
        return (_a = synDataInternal === null || synDataInternal === void 0 ? void 0 : synDataInternal.currentStep) === null || _a === void 0 ? void 0 : _a.name;
    }
    //#region Helpers
    static getData($elem) {
        return $elem.data("synWizard");
    }
    static setData($elem, data) {
        $elem.data("synWizard", data);
    }
    static removeData($elem) {
        $elem.removeData("synWizard");
    }
    static getDataInternal($elem) {
        return $elem.data("synWizardInternal");
    }
    static setDataInternal($elem, data) {
        $elem.data("synWizardInternal", data);
    }
    static removeDataInternal($elem) {
        $elem.removeData("synWizardInternal");
    }
    static resetWizard($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synDataInternal = WizardImpl.getDataInternal($elem);
            yield WizardImpl.resetGlobalStorage($elem);
            synDataInternal.pathStorage = [{ step: synDataInternal.currentStep, data: {} }];
            synDataInternal.stepHistory = [];
            synDataInternal.haveRunSteps = [];
            synDataInternal.finished = false;
        });
    }
    static getStepByName($elem, stepName) {
        var _a;
        let synData = WizardImpl.getData($elem);
        let returnStep;
        (_a = synData === null || synData === void 0 ? void 0 : synData.WizardSteps) === null || _a === void 0 ? void 0 : _a.forEach((step) => {
            if (step.name === stepName) {
                returnStep = step;
                return false;
            }
        });
        if (!returnStep)
            $.error("jQuery.synWizard getStepByName received a nonexisting stepName \"" + stepName + "\"");
        return returnStep;
    }
    static rebuildStepContentDiv($elem) {
        let id = $elem.find(".synWizardContent").first().attr("id");
        $elem.find(".synWizardContent").first().remove();
        $elem.find(".synWizard").append("<div id='" + id + "' class='synWizardContent'></div>");
    }
    static enablePreviousButton($elem, enable = true) {
        if (enable === true)
            $elem.find(".synWizardBtn-previous").prop("disabled", false);
        else
            $elem.find(".synWizardBtn-previous").prop("disabled", true);
    }
    static printDotGraph($elem) {
        let synData = WizardImpl.getData($elem);
        if (synData) {
            let dotGraph = "digraph wizardsteps {";
            synData.WizardSteps.forEach((step) => {
                dotGraph += "\"" + step.name + "\" ";
                if (step.nextPossibleSteps)
                    step.nextPossibleSteps.forEach((nextStepName) => {
                        dotGraph += "\"" + step.name + "\" -> \"" + nextStepName + "\" ";
                    });
            });
            dotGraph += "}";
        }
    }
    static hasNoLoops(wizardSteps, currentStep, pathHistory) {
        // Check if currentStep is already in pathHistory
        for (let historyStep of pathHistory) {
            if (currentStep.name === historyStep.name)
                return false;
        }
        let newPathHistory = pathHistory.slice();
        newPathHistory.push(currentStep);
        let noLoops = true;
        if (currentStep.nextPossibleSteps) {
            for (let nextStepName of currentStep.nextPossibleSteps) {
                for (let step of wizardSteps) {
                    if (nextStepName === step.name)
                        noLoops = noLoops && this.hasNoLoops(wizardSteps, step, newPathHistory);
                }
            }
        }
        return noLoops;
    }
    static checkStepsAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = WizardImpl.getData($elem);
            if (synData) {
                let validStepGraph = true;
                let startStep;
                let allNodes = [];
                if (!synData.WizardSteps || synData.WizardSteps.length === 0)
                    $.error("jQuery.synWizard can't be initialized without WizardSteps");
                synData.WizardSteps.forEach((step) => {
                    allNodes.push(step.name);
                });
                let startNodes = allNodes.slice();
                let endNodes = allNodes.slice();
                let nodesMissingGetNextStepName = [];
                let endNodesCanReRunPromises = [];
                let uniqueStepNames = [];
                synData.WizardSteps.forEach((step) => {
                    // Add nodes with unique names to check for duplicates later
                    if (uniqueStepNames.indexOf(step.name) === -1)
                        uniqueStepNames.push(step.name);
                    const nextStepCount = step.nextPossibleSteps ? step.nextPossibleSteps.length : 0;
                    // Find nodes with more than one nextPossibleStep but no getNextStepName()
                    if (nextStepCount > 1 && step.getNextStepName == undefined) {
                        nodesMissingGetNextStepName.push(step.name);
                    }
                    // Find nodes that are endNodes but have canReRun() set
                    if (nextStepCount === 0)
                        endNodesCanReRunPromises.push(WizardImpl.evaluateCanReRun($elem, step));
                    // Remove nodes that aren't startNodes
                    if (step.nextPossibleSteps)
                        step.nextPossibleSteps.forEach((nextStep) => {
                            for (let i = startNodes.length - 1; i >= 0; --i) {
                                if (nextStep === startNodes[i])
                                    startNodes.splice(i, 1);
                            }
                        });
                    // Remove nodes that aren't endNodes
                    if (nextStepCount !== 0) {
                        for (let i = endNodes.length - 1; i >= 0; --i) {
                            if (step.name === endNodes[i])
                                endNodes.splice(i, 1);
                        }
                    }
                });
                if (uniqueStepNames.length !== allNodes.length) {
                    validStepGraph = false;
                    // eslint-disable-next-line no-console
                    console.warn("jQuery.synWizard has two or more steps with the same name");
                }
                if (nodesMissingGetNextStepName.length > 0) {
                    validStepGraph = false;
                    let invalidSteps = nodesMissingGetNextStepName.join(", ");
                    // eslint-disable-next-line no-console
                    console.warn("jQuery.synWizard steps (" + invalidSteps + ") have more than one nextPossibleSteps, but no getNextStepName function is set");
                }
                const canReRunValues = yield Promise.all(endNodesCanReRunPromises);
                const invalidCanReRunStepNames = canReRunValues
                    .map((v, idx) => v ? undefined : synData.WizardSteps[idx].name)
                    .filter(stepName => stepName != undefined);
                if (invalidCanReRunStepNames.length > 0) {
                    validStepGraph = false;
                    // eslint-disable-next-line no-console
                    console.warn("jQuery.synWizard steps (" + invalidCanReRunStepNames.join(", ") + ") are endNodes, but have canReRun() evaluating to false. This is invalid for end nodes");
                }
                if (startNodes.length !== 1) {
                    validStepGraph = false;
                    // eslint-disable-next-line no-console
                    console.warn("jQuery.synWizard has no or more than one startNode");
                }
                if (endNodes.length < 1) {
                    validStepGraph = false;
                    // eslint-disable-next-line no-console
                    console.warn("jQuery.synWizard has no endNodes (Nodes without nextPossibleSteps)");
                }
                if (validStepGraph) {
                    // Check for loops
                    for (let step of synData.WizardSteps) {
                        if (step.name === startNodes[0]) {
                            startStep = step;
                            break;
                        }
                    }
                    if (!WizardImpl.hasNoLoops(synData.WizardSteps, startStep, [])) {
                        validStepGraph = false;
                        // eslint-disable-next-line no-console
                        console.warn("jQuery.synWizard contains a loop");
                    }
                }
                // Set internal data
                if (validStepGraph) {
                    // Get the longest path
                    let pathLengths = [];
                    let nodesToProcess = [];
                    let followPath = function (stepWithCount) {
                        let newCount = stepWithCount.count + 1;
                        let currentStep = stepWithCount.currentStep;
                        if (!currentStep.nextPossibleSteps || currentStep.nextPossibleSteps.length === 0)
                            pathLengths.push(newCount);
                        else {
                            for (let nextStepName of currentStep.nextPossibleSteps) {
                                nodesToProcess.push({
                                    currentStep: WizardImpl.getStepByName($elem, nextStepName),
                                    count: newCount
                                });
                            }
                        }
                    };
                    nodesToProcess.push({ currentStep: WizardImpl.getStepByName($elem, startNodes[0]), count: 0 });
                    while (nodesToProcess.length > 0)
                        followPath(nodesToProcess.pop());
                    pathLengths.sort((a, b) => b - a);
                    // Set data
                    let internalOptions = {
                        startStep: startNodes[0],
                        longestPathLength: pathLengths[0],
                        globalStorage: {},
                        pathStorage: [{ step: startStep, data: {} }],
                    };
                    WizardImpl.setDataInternal($elem, internalOptions);
                }
                return validStepGraph;
            }
            else
                return false;
        });
    }
    static hasHistoryStepThatCanRun($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synDataInternal = WizardImpl.getDataInternal($elem);
            Promise.resolve(true);
            if (synDataInternal.stepHistory.length === 0)
                return false;
            for (let historyStep of synDataInternal.stepHistory) {
                if (yield WizardImpl.evaluateCanReRun($elem, historyStep))
                    return true;
            }
            return false;
        });
    }
    static getButtonTextForStep($elem, step, btnType) {
        let synData = WizardImpl.getData($elem);
        let btnText = Utilities_1.synUtil.Strings.getValue("synwizard." + synData.WizardName + "." + step.name + "." + btnType, "");
        if (btnText === "")
            btnText = Utilities_1.synUtil.Strings.getValue("synwizard." + synData.WizardName + "." + btnType, "");
        if (btnText === "")
            btnText = Utilities_1.synUtil.Strings.getValue("synwizard." + btnType);
        return btnText;
    }
    static createWizardNavigationAsync($elem, rememberButtonStatus = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = WizardImpl.getData($elem);
            let synDataInternal = WizardImpl.getDataInternal($elem);
            let $synWizardNavigation = $elem.find(".synWizardNavigation").first();
            let stepTemplate = "<div class='synWizardStep'><div class='synWizardStepIcon'></div><span></span></div>";
            let stepWidthPercent = (100 / synDataInternal.longestPathLength).toFixed(2);
            if (Utilities_1.synUtil.clientDeviceClass === "phone")
                stepWidthPercent = "100";
            let cancelButtonVisible;
            let previousButtonVisible;
            let nextButtonVisible;
            let nextButtonStatusEnabled;
            if (rememberButtonStatus) {
                cancelButtonVisible = $elem.find(".synWizardBtn-next").css("visibility");
                previousButtonVisible = $elem.find(".synWizardBtn-next").css("visibility");
                nextButtonStatusEnabled = !$elem.find(".synWizardBtn-next").prop("disabled");
                nextButtonVisible = $elem.find(".synWizardBtn-next").css("visibility");
            }
            $synWizardNavigation.empty();
            // History steps
            if (Utilities_1.synUtil.clientDeviceClass !== "phone") {
                for (let historyStep of synDataInternal.stepHistory) {
                    let $historyStep = $(stepTemplate);
                    $historyStep.addClass("synWizardHistoryStep");
                    if (historyStep.iconUrl)
                        $("<img>")
                            .addClass("customStepIcon")
                            .attr("src", historyStep.iconUrl)
                            .appendTo($historyStep.find(".synWizardStepIcon").html(""));
                    else
                        $historyStep.find(".synWizardStepIcon").append("<i class='fa fa-check'></i>");
                    $historyStep.find("span").text(Utilities_1.synUtil.Strings.getValue("synWizard." + synData.WizardName + "." + historyStep.name + ".name"));
                    if ((yield WizardImpl.evaluateCanReRun($elem, historyStep)) === false)
                        $historyStep.addClass("synWizardDisabledStep");
                    else
                        $historyStep.on("click", () => { WizardImpl.previousStep($elem, historyStep); });
                    $synWizardNavigation.append($historyStep);
                }
            }
            // Current step
            let $currentStep = $(stepTemplate);
            $currentStep.addClass("synWizardCurrentStep");
            if (synDataInternal.currentStep.iconUrl)
                $("<img>")
                    .addClass("customStepIcon")
                    .attr("src", synDataInternal.currentStep.iconUrl)
                    .appendTo($currentStep.find(".synWizardStepIcon").html(""));
            else
                $currentStep.find(".synWizardStepIcon").append("<i class='fa fa-pencil'></i>");
            $currentStep.find("span").text(Utilities_1.synUtil.Strings.getValue("synWizard." + synData.WizardName + "." + synDataInternal.currentStep.name + ".name"));
            $synWizardNavigation.append($currentStep);
            // Description for current step
            let description = Utilities_1.synUtil.Strings.getValue("synWizard." + synData.WizardName + "." + synDataInternal.currentStep.name + ".description", "");
            if (description === "")
                $elem.find(".synWizardDescription").css("display", "none");
            else
                $elem.find(".synWizardDescription").css("display", "block").text(description);
            // Future steps
            if (Utilities_1.synUtil.clientDeviceClass !== "phone") {
                let futureStep;
                let addDummyStep = false;
                if (synDataInternal.currentStep.nextPossibleSteps && synDataInternal.currentStep.nextPossibleSteps.length === 1)
                    futureStep = WizardImpl.getStepByName($elem, synDataInternal.currentStep.nextPossibleSteps[0]);
                else if (synDataInternal.currentStep.nextPossibleSteps && synDataInternal.currentStep.nextPossibleSteps.length > 1) {
                    if (synDataInternal.currentStep.getNextStepNamePrediction != undefined) {
                        let futureStepNameOrPromise = synDataInternal.currentStep.getNextStepNamePrediction($elem);
                        if (futureStepNameOrPromise == undefined)
                            addDummyStep = true;
                        else {
                            let futureStepName;
                            if (typeof futureStepNameOrPromise === "string")
                                futureStepName = futureStepNameOrPromise;
                            else
                                futureStepName = yield futureStepNameOrPromise;
                            if (futureStepName == undefined)
                                addDummyStep = true;
                            else
                                futureStep = WizardImpl.getStepByName($elem, futureStepName);
                        }
                    }
                    else
                        addDummyStep = true;
                }
                while (futureStep != undefined) {
                    let $futureStep = $(stepTemplate);
                    $futureStep.addClass("synWizardFutureStep");
                    $futureStep.find("span").text(Utilities_1.synUtil.Strings.getValue("synWizard." + synData.WizardName + "." + futureStep.name + ".name"));
                    const disabledStep = synDataInternal.haveRunSteps.indexOf(futureStep) !== -1 && (yield WizardImpl.evaluateCanReRun($elem, futureStep)) === false;
                    if (disabledStep)
                        $futureStep.addClass("synWizardDisabledStep");
                    if (futureStep.iconUrl)
                        $("<img>")
                            .addClass("customStepIcon")
                            .attr("src", futureStep.iconUrl)
                            .appendTo($futureStep.find(".synWizardStepIcon").html(""));
                    else {
                        if (disabledStep)
                            $futureStep.find(".synWizardStepIcon").append("<i class='fa fa-check'></i>");
                        else
                            $futureStep.find(".synWizardStepIcon").append("<i class='fa fa-pencil'></i>");
                        if (!futureStep.nextPossibleSteps || futureStep.nextPossibleSteps.length === 0) {
                            futureStep = undefined;
                            $futureStep.addClass("synWizardEndStep");
                        }
                        else if (futureStep.nextPossibleSteps.length === 1)
                            futureStep = WizardImpl.getStepByName($elem, futureStep.nextPossibleSteps[0]);
                        else if (futureStep.getNextStepNamePrediction != undefined) {
                            let futureStepNameOrPromise = futureStep.getNextStepNamePrediction($elem);
                            if (futureStepNameOrPromise == undefined) {
                                futureStep = undefined;
                                addDummyStep = true;
                            }
                            else {
                                let futureStepName;
                                if (typeof futureStepNameOrPromise === "string")
                                    futureStepName = futureStepNameOrPromise;
                                else
                                    futureStepName = yield futureStepNameOrPromise;
                                if (futureStepName == undefined) {
                                    futureStep = undefined;
                                    addDummyStep = true;
                                }
                                else
                                    futureStep = WizardImpl.getStepByName($elem, futureStepName);
                            }
                        }
                        else {
                            futureStep = undefined;
                            addDummyStep = true;
                        }
                        $synWizardNavigation.append($futureStep);
                    }
                    if (addDummyStep) {
                        let $dummyStep = $(stepTemplate);
                        $dummyStep.addClass("synWizardDummyStep");
                        $dummyStep.find(".synWizardStepIcon").append("<i class='fa fa-ellipsis-h'></i>");
                        $synWizardNavigation.append($dummyStep);
                    }
                }
                if (synData.HeaderRenderingMode === "Classic")
                    $synWizardNavigation.children(".synWizardStep").css("width", stepWidthPercent + "%");
                else {
                    $synWizardNavigation.addClass("adaptive");
                    if (synData.HeaderRenderingMode === "Adaptive") {
                        const $currentStep = $synWizardNavigation.children(".synWizardCurrentStep");
                        const navigationWidth = $synWizardNavigation.innerWidth();
                        const currentStepWidth = $currentStep.outerWidth(true);
                        let sumWidthHistory = 0;
                        $synWizardNavigation.children(".synWizardHistoryStep").each((_idx, elem) => {
                            sumWidthHistory += $(elem).outerWidth(true);
                        });
                        $synWizardNavigation.animate({
                            scrollLeft: sumWidthHistory + (currentStepWidth - navigationWidth) / 2
                        }, 100, "swing", () => {
                            const fadeWidthPercentage = 15;
                            const currentStepLeft = $currentStep.position().left;
                            let fadeLeft = currentStepLeft > navigationWidth * fadeWidthPercentage / 100;
                            let fadeRight = currentStepLeft + currentStepWidth < navigationWidth * (100 - fadeWidthPercentage) / 100;
                            //linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 15%, rgba(0,0,0,1) 85%, rgba(0,0,0,0) 100%)
                            const gradient = "linear-gradient(90deg," +
                                "rgba(0,0,0," + (fadeLeft ? "0" : "1") + ") 0%," +
                                "rgba(0,0,0,1) " + fadeWidthPercentage.toString() + "%," +
                                "rgba(0,0,0,1) " + (100 - fadeWidthPercentage).toString() + "%," +
                                "rgba(0,0,0," + (fadeRight ? "0" : "1") + ") 100%" +
                                ")";
                            $synWizardNavigation.css({
                                "mask-image": gradient,
                                "-webkit-mask-image": gradient
                            });
                        });
                    }
                }
                // Cancel button
                let $synWizardBtnCancel = $elem.find(".synWizardBtn-cancel:not(.placeholder)");
                $synWizardBtnCancel.off("click").on("click", (e) => {
                    $elem.trigger("synWizardCancel");
                });
                if (synData.CancelIconId)
                    $("<img>")
                        .addClass("customNavigationIcon")
                        .attr("src", `${Utilities_1.synUtil.getWSUrl("Icon")}${synData.CancelIconId}/36`)
                        .appendTo($synWizardBtnCancel.html(""));
                else
                    $synWizardBtnCancel.text(WizardImpl.getButtonTextForStep($elem, synDataInternal.currentStep, "btncancel"));
                if (cancelButtonVisible) {
                    if (cancelButtonVisible === "hidden")
                        WizardImpl.hideBtnCancel($elem);
                }
                else {
                    if (synDataInternal.currentStep.hideBtnCancel === true)
                        WizardImpl.hideBtnCancel($elem);
                    else
                        WizardImpl.hideBtnCancel($elem, false);
                }
                // Previous button
                let $synWizardBtnPrevious = $elem.find(".synWizardBtn-previous:not(.placeholder)");
                if (synDataInternal.stepHistory && (synDataInternal.stepHistory.length === 0 || !(yield WizardImpl.hasHistoryStepThatCanRun($elem))))
                    WizardImpl.enablePreviousButton($elem, false);
                else {
                    WizardImpl.enablePreviousButton($elem);
                    $synWizardBtnPrevious.off("click").on("click", (e) => {
                        WizardImpl.previousStep($elem);
                    });
                }
                if (synData.PreviousIconId)
                    $("<img>")
                        .addClass("customNavigationIcon")
                        .attr("src", `${Utilities_1.synUtil.getWSUrl("Icon")}${synData.PreviousIconId}/36`)
                        .appendTo($synWizardBtnPrevious.html(""));
                else
                    $synWizardBtnPrevious.text(WizardImpl.getButtonTextForStep($elem, synDataInternal.currentStep, "btnprevious"));
                if (previousButtonVisible) {
                    if (previousButtonVisible === "hidden")
                        WizardImpl.hideBtnPrevious($elem);
                }
                else {
                    if (synDataInternal.currentStep && synDataInternal.currentStep.hideBtnPrevious === true)
                        WizardImpl.hideBtnPrevious($elem);
                    else
                        WizardImpl.hideBtnPrevious($elem, false);
                }
                // Next button (Always disabled after step changed)
                let $synWizardBtnNext = $elem.find(".synWizardBtn-next:not(.placeholder)");
                $synWizardBtnNext.off("click").on("click", (e) => {
                    WizardImpl.nextStep($elem).catch((reason) => {
                        // eslint-disable-next-line no-console
                        console.warn("synWizard.nextStep failed due to: " + reason);
                    });
                });
                if (synData.NextIconId)
                    $("<img>")
                        .addClass("customNavigationIcon")
                        .attr("src", `${Utilities_1.synUtil.getWSUrl("Icon")}${synData.NextIconId}/36`)
                        .appendTo($synWizardBtnNext.html(""));
                else
                    $synWizardBtnNext.text(WizardImpl.getButtonTextForStep($elem, synDataInternal.currentStep, "btnnext"));
                if (nextButtonStatusEnabled != undefined)
                    WizardImpl.enableNextButton($elem, nextButtonStatusEnabled);
                else
                    WizardImpl.enableNextButton($elem, false);
                if (nextButtonVisible) {
                    if (nextButtonVisible === "hidden")
                        WizardImpl.hideBtnNext($elem);
                }
                else {
                    if (synDataInternal.currentStep && synDataInternal.currentStep.hideBtnNext === true)
                        WizardImpl.hideBtnNext($elem);
                    else
                        WizardImpl.hideBtnNext($elem, false);
                }
                // Placeholder buttons (contain longest button texts to avoid steps jumping)
                if (Utilities_1.synUtil.clientDeviceClass !== "phone") {
                    let longestBtnCancelText = "";
                    let longestBtnPreviousText = "";
                    let longestBtnNextText = "";
                    let $placeholderBtnCancel = $elem.find(".synWizardPlaceholderButtons .synWizardBtn-cancel");
                    let $placeholderBtnPrevious = $elem.find(".synWizardPlaceholderButtons .synWizardBtn-previous");
                    let $placeholderBtnNext = $elem.find(".synWizardPlaceholderButtons .synWizardBtn-next");
                    if (synData.WizardSteps)
                        for (let step of synData.WizardSteps) {
                            let btnCancelText = WizardImpl.getButtonTextForStep($elem, step, "btncancel");
                            let btnPreviousText = WizardImpl.getButtonTextForStep($elem, step, "btnprevious");
                            let btnNextText = WizardImpl.getButtonTextForStep($elem, step, "btnnext");
                            if (btnCancelText.length > longestBtnCancelText.length)
                                longestBtnCancelText = btnCancelText;
                            if (btnPreviousText.length > longestBtnPreviousText.length)
                                longestBtnPreviousText = btnPreviousText;
                            if (btnNextText.length > longestBtnNextText.length)
                                longestBtnNextText = btnNextText;
                        }
                    $placeholderBtnCancel.text(longestBtnCancelText).css("visibility", "hidden");
                    $placeholderBtnPrevious.text(longestBtnPreviousText).css("visibility", "hidden");
                    $placeholderBtnNext.text(longestBtnNextText).css("visibility", "hidden");
                }
                // Set mobile display
                if (Utilities_1.synUtil.clientDeviceClass === "phone") {
                    $elem.addClass("synWizardMobile");
                    $elem.find(".synWizardPlaceholderButtons").remove();
                    // Unset min-width
                    $synWizardBtnCancel.css("min-width", "");
                    $synWizardBtnPrevious.css("min-width", "");
                    $synWizardBtnNext.css("min-width", "");
                    // Set buttons to same min-width
                    let buttonWidths = [];
                    buttonWidths.push($synWizardBtnCancel.width());
                    buttonWidths.push($synWizardBtnPrevious.width());
                    buttonWidths.push($synWizardBtnNext.width());
                    buttonWidths.sort((a, b) => b - a);
                    $synWizardBtnCancel.css("min-width", buttonWidths[0]);
                    $synWizardBtnPrevious.css("min-width", buttonWidths[0]);
                    $synWizardBtnNext.css("min-width", buttonWidths[0]);
                    // Make buttons slimmer by 10px for vertical display
                    $(".synWizardBtn").css("height", "30px");
                }
            }
            //#endregion Helpers
        });
    }
}
WizardImpl.DefaultOptions = {
    WizardName: "",
    WizardSteps: undefined,
    OutputDebugGraph: false,
    HeaderRenderingMode: "Classic"
};
// Dispatcher code
(($) => {
    $.fn.synWizard = function () {
        if (!arguments.length)
            $.error("jQuery.synWizard can't be initialized without WizardOptions");
        else if (typeof arguments[0] === "object")
            return WizardImpl.initAsync.apply(undefined, [this].concat(Array.prototype.slice.call(arguments)));
        // Dispatch to all other functions, if they exist
        else if (typeof arguments[0] === "string" && WizardImpl[arguments[0]])
            return WizardImpl[arguments[0]].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synWizard");
    };
})(jQuery);
